export default "__VITE_ASSET__BJdrlqvJ__"